import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaypalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"paypal"}/>
}
